<template>
  <v-btn :color="color" depressed outlined @click="onClick">
    {{ text }}
  </v-btn>
</template>

<script>
export default {
  props: {
    text: { type: String, required: true },
    value: { type: Boolean, default: false }
  },
  data() {
    return {
      active: false
    }
  },
  computed: {
    color() {
      return this.active ? 'primary' : 'mediumTwo'
    }
  },
  created() {
    this.active = this.value
  },
  methods: {
    onClick() {
      this.active = !this.active
      this.$emit('input', this.active)
    }
  }
}
</script>
